import * as api from '~/myApi'

export interface Option<T> {
  label: string
  value: number | T
  key: T,
  enumKey?: string
}

// TypesTargetRatio


export type CLUSTER_RATIO_OPTION = Omit<Option<keyof api.TypesClusterRatio>, 'value'>
export const CLUSTER_RATIO: (CLUSTER_RATIO_OPTION)[] = [
  {
    label: 'MTeen',
    key: 'clusterMarketMteenRatio',
    enumKey: api.EnumsCluster.CLUSTER_MARKET_MTEEN
  },
  {
    label: 'M1',
    key: 'clusterMarketM1Ratio',
    enumKey: api.EnumsCluster.CLUSTERMARKETM1
  },
  {
    label: 'M2',
    key: 'clusterMarketM2Ratio',
    enumKey: api.EnumsCluster.CLUSTERMARKETM2
  },
  {
    label: 'M3',
    key: 'clusterMarketM3Ratio',
    enumKey: api.EnumsCluster.CLUSTERMARKETM3
  },
  {
    label: 'Fteen',
    key: 'clusterMarketFteenRatio',
    enumKey: api.EnumsCluster.CLUSTER_MARKET_FTEEN
  },
  {
    label: 'F1',
    key: 'clusterMarketF1Ratio',
    enumKey: api.EnumsCluster.CLUSTERMARKETF1
  },
  {
    label: 'F2',
    key: 'clusterMarketF2Ratio',
    enumKey: api.EnumsCluster.CLUSTERMARKETF2
  },
  {
    label: 'F3',
    key: 'clusterMarketF3Ratio',
    enumKey: api.EnumsCluster.CLUSTERMARKETF3
  },
  {
    label: 'M10s',
    key: 'clusterTensM10sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSM10S
  },
  {
    label: 'M20s',
    key: 'clusterTensM20sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSM20S
  },
  {
    label: 'M30s',
    key: 'clusterTensM30sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSM30S
  },
  {
    label: 'M40s',
    key: 'clusterTensM40sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSM40S
  },
  {
    label: 'M50s',
    key: 'clusterTensM50sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSM50S
  },
  {
    label: 'F10s',
    key: 'clusterTensF10sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSF10S
  },
  {
    label: 'F20s',
    key: 'clusterTensF20sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSF20S
  },
  {
    label: 'F30s',
    key: 'clusterTensF30sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSF30S
  },
  {
    label: 'F40s',
    key: 'clusterTensF40sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSF40S
  },
  {
    label: 'F50s',
    key: 'clusterTensF50sRatio',
    enumKey: api.EnumsCluster.CLUSTERTENSF50S
  },
  {
    label: '男性',
    key: 'clusterGenderMaleRatio',
    enumKey: api.EnumsCluster.CLUSTER_GENDER_MALE
  },
  {
    label: '女性',
    key: 'clusterGenderFemaleRatio',
    enumKey: api.EnumsCluster.CLUSTER_GENDER_FEMALE
  },
]

export type CLUSTER_TYPE_OPTION = Option<keyof typeof api.EnumsClusterType>
export const CLUSTER_TYPE: (CLUSTER_TYPE_OPTION & { items?: CLUSTER_RATIO_OPTION[] })[] = [
  {
    label: 'マーケティング区分',
    value: api.EnumsClusterType.CLUSTER_TYPE_MARKET_CLUSTER,
    key: api.EnumsClusterType.CLUSTER_TYPE_MARKET_CLUSTER,
    items: CLUSTER_RATIO.filter(({ key }) => ~key.indexOf('clusterMarket'))
  },
  {
    label: '10代区分',
    value: api.EnumsClusterType.CLUSTER_TYPE_TENS_CLUSTER,
    key: api.EnumsClusterType.CLUSTER_TYPE_TENS_CLUSTER,
    items: CLUSTER_RATIO.filter(({ key }) => ~key.indexOf('clusterTens'))
  },
  {
    label: '男女',
    value: api.EnumsClusterType.CLUSTER_TYPE_GENDER,
    key: api.EnumsClusterType.CLUSTER_TYPE_GENDER,
    items: CLUSTER_RATIO.filter(({ key }) => ~key.indexOf('clusterGender'))
  },
];



// TypesTargetRatio
export const OS_RATIO: Omit<Option<keyof api.TypesOSRatio>, 'value'>[] = [
  {
    label: 'iOS',
    key: 'osIosRatio',
    enumKey: api.EnumsOS.OS_IOS
  },
  {
    label: 'Android',
    key: 'osAndroidRatio',
    enumKey: api.EnumsOS.OS_ANDROID
  },
  {
    label: 'その他',
    key: 'osOtherRatio',
    enumKey: api.EnumsOS.OS_OTHER_OS
  },
]

export const CARRER_RATIO: Omit<Option<keyof api.TypesCarrerRatio>, 'value'>[] = [
  {
    label: 'docomo',
    key: 'careerDocomoRatio',
    enumKey: api.EnumsCarrer.CARRER_DOCOMO
  },
  {
    label: 'au',
    key: 'careerAuRatio',
    enumKey: api.EnumsCarrer.CARRER_AU
  },
  {
    label: 'softbank',
    key: 'careerSoftbankRatio',
    enumKey: api.EnumsCarrer.CARRER_SOFTBANK
  },
  {
    label: 'その他',
    key: 'careerOtherRatio',
    enumKey: api.EnumsCarrer.CARRER_OTHER_CARRER
  },
]

export const DEVICE_RATIO: Omit<Option<keyof api.TypesDeviceRatio>, 'value'>[] = [
  {
    label: 'PC',
    key: 'devicePcRatio',
    enumKey: api.EnumsDevice.DEVICE_PC
  },
  {
    label: 'TV',
    key: 'deviceTvRatio',
    enumKey: api.EnumsDevice.DEVICE_TV
  },
  {
    label: 'スマホ／タブレット',
    key: 'deviceSpRatio',
    enumKey: api.EnumsDevice.DEVICE_SP
  },
  {
    label: 'その他',
    key: 'deviceOtherRatio',
    enumKey: api.EnumsDevice.DEVICE_OTHER
  },
]

export const AD_CONTACT_STATUS_RATIO: Omit<Option<keyof api.TypesAdContactStatusRatio>, 'value'>[] = [
  {
    label: '接触',
    key: 'adContactStatusTrueRatio',
    enumKey: api.EnumsAdContactStatus.AD_CONTACT_STATUS_TRUE
  },
  {
    label: '非接触',
    key: 'adContactStatusFalseRatio',
    enumKey: api.EnumsAdContactStatus.AD_CONTACT_STATUS_FALSE
  },
]

export type QUESTION_TYPE_OPTION = Option<keyof typeof api.EnumsQuestionType>
export const QUESTION_TYPE: QUESTION_TYPE_OPTION[] = [
  {
    label: 'シングル（ ラジオボタン ）',
    value: api.EnumsQuestionType.QUESTION_TYPE_SINGLE_ANSWER,
    key: api.EnumsQuestionType.QUESTION_TYPE_SINGLE_ANSWER,
  },
  {
    label: 'マルチ（ チェックボックス ）',
    value: api.EnumsQuestionType.QUESTION_TYPE_MULTI_ANSWER,
    key: api.EnumsQuestionType.QUESTION_TYPE_MULTI_ANSWER,
  },
]

export type SURVEY_TYPE_OPTION = Option<keyof typeof api.EnumsSurveyType>
export const SURVEY_TYPE: SURVEY_TYPE_OPTION[] = [
  {
    label: '事前調査',
    value: api.EnumsSurveyType.SURVEY_TYPE_PRE_AD,
    key: api.EnumsSurveyType.SURVEY_TYPE_PRE_AD,
  },
  {
    label: '広告効果測定',
    value: api.EnumsSurveyType.SURVEY_TYPE_AD_CONTACT,
    key: api.EnumsSurveyType.SURVEY_TYPE_AD_CONTACT,
  },
]

export type SURVEY_STATUS_OPTION = Option<keyof typeof api.EnumsSurveyStatus>
export const SURVEY_STATUS: SURVEY_STATUS_OPTION[] = [
  {
    label: 'ON',
    value: api.EnumsSurveyStatus.SURVEY_STATUS_ON,
    key: api.EnumsSurveyStatus.SURVEY_STATUS_ON,
  },
  {
    label: 'OFF',
    value: api.EnumsSurveyStatus.SURVEY_STATUS_OFF,
    key: api.EnumsSurveyStatus.SURVEY_STATUS_OFF,
  },
]